<div class="layers" [formGroup]="layers">
    <span>Data source(s) to process:</span>
    <mat-checkbox formControlName="city" [disabled]="disableLayers">City</mat-checkbox>
    <mat-checkbox formControlName="county" [disabled]="disableLayers">County</mat-checkbox>
    <mat-checkbox formControlName="state" [disabled]="disableLayers">State</mat-checkbox>
</div>